module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-new-arrow-left-icon.468c9aed.svg";